import '../../index.css';
var styles = {
  "grid": "bp_select_menu_grid_module_grid--6e766",
  "row": "bp_select_menu_grid_module_row--6e766"
};
export { styles as default };